import { useEffect } from "react";

export function useFocusVisibility() {
  useEffect(() => {
    const root = document.documentElement;

    // Programmatic focus can inherit :focus-visible even after a mouse click.
    // Track intent before controls move focus, including controls in portals.
    function pointerDown() {
      root.dataset.inputModality = "pointer";
    }

    function keyDown(event) {
      if (event.metaKey || event.altKey || event.ctrlKey) return;
      // Dismissing a mouse-opened overlay is not keyboard navigation.
      // Keep the current modality when focus returns to its trigger.
      if (event.key === "Escape") return;
      if (["Shift", "Control", "Alt", "Meta"].includes(event.key)) return;
      root.dataset.inputModality = "keyboard";
    }

    document.addEventListener("pointerdown", pointerDown, true);
    document.addEventListener("keydown", keyDown, true);
    return () => {
      document.removeEventListener("pointerdown", pointerDown, true);
      document.removeEventListener("keydown", keyDown, true);
      delete root.dataset.inputModality;
    };
  }, []);
}
